<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface ProseAProps {
  href?: string
  target?: '_blank' | '_parent' | '_self' | '_top' | (string & object) | null | undefined
  class?: HTMLAttributes['class']
}

export interface ProseASlots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseAProps>()
defineSlots<ProseASlots>()

const { data: templateData } = useQueryTemplate.byId({
  id: props.href ?? '',
  useQueryOptions: {
    enabled: () => !!props.href && props.href.length === 6,
  },
})

const template = computed(() => templateData.value?.data)

const links = useLinks()
const link = computed(() => template.value ? links.template(template.value.id) : props.href)

const target = computed(() => props?.target ?? (!template.value ? '_blank' : undefined))
</script>

<template>
  <NuxtLink
    :href="link"
    :target
    :class="props.class"
    class="font-medium text-blue-600 underline hover:text-blue-800"
    @click="$posthog.capture('chat_link_clicked', { link: props.href })"
  >
    <slot />
  </NuxtLink>
</template>
